import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=2b7c8f0e&scoped=true&"
import script from "./BlockForm.vue?vue&type=script&lang=js&"
export * from "./BlockForm.vue?vue&type=script&lang=js&"
import style0 from "./BlockForm.vue?vue&type=style&index=0&id=2b7c8f0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c8f0e",
  null
  
)

export default component.exports